import {ETheme, EMenuIntro} from '@/constants/conf';
import {TranslateResult} from 'vue-i18n';


export interface IMainMenuItem {
    title?: TranslateResult;  // libellé dans le menu
    segment?: TranslateResult;  // segment d'url
    theme: ETheme; // theme de couleur de l'item
    pageTheme?: ETheme; // theme du logo + burger
    intro: EMenuIntro; // le type d'intro souhaitée pour l'apparition
    image?: string|IMainMenuItemI18N; // l'image de fond de litem (peut etre ajusté en fonction du marché)
    imageOffset?: string, // decalage  de l'image dans le menu : exemple : 20% center, 100px (correspond à la prop css background-position)
    pageComponent: string|IMainMenuItemI18N; // nom du composant qui sera chargé sur la page  (peut etre ajusté en fonction du marché)
}

export interface IMainMenuItemI18N {
    [key:string]: any; // Add index signature
}


export const mainMenu: Array<IMainMenuItem> = [
    
    {
        pageComponent: 'Travel',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Travel_cover.jpg',
        imageOffset: '35% center',
    },
    {
        pageComponent: 'KeyReport',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'KeyReport_cover.jpg',
        imageOffset: '32% center',
    },
    {
        pageComponent: 'Entrepreneurs',
        theme: ETheme.DARK,
        intro: EMenuIntro.ARTICLE,
        image: 'Entrepreneurs_cover.jpg',
        imageOffset: '40% top',
    },
    {
        pageComponent: 'ArtyWilmotte',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'ArtyWilmotte_cover.jpg',
        imageOffset: 'left center',
    },
    {
        theme: ETheme.LIGHT,
        intro: EMenuIntro.POINTOFVIEW,
        image: {
            EN : 'Edito_Patrick-Follea_cover.jpg',
            FR : 'Edito_Mathieu-Vedrenne_cover.jpg',
            MC : 'Edito_Alexandre-Rousseau_cover.jpg',
            LU : 'Edito_Olivier-Lecler_cover.jpg',
            CH : 'Edito_Franck-Bonin_cover.jpg',
            UK : 'Edito_Mouhammed-Choukeir_cover.jpg',
        },
        pageComponent: {
            EN : 'EditoEN',
            FR : 'EditoFR',
            MC : 'EditoMC',
            CH : 'EditoCH',
            LU : 'EditoLU',
            UK : 'EditoUK',
        },
    },
    {
        pageComponent: 'Future',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Future_cover.jpg',
        imageOffset: '22% center',
    },
    {
        pageComponent: 'TrendingNow',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        image: 'TrendingNow_cover.jpg',
        imageOffset: 'left 30% center',
    },
    {
        pageComponent: 'Tune',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'Tune_cover.jpg',
        imageOffset: 'right 32% center',
    },
    {
        pageComponent: 'ArtyMirror',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.ARTICLE,
        image: 'ArtyMirror_cover.jpg',
        imageOffset: 'left center',
    },
    {
        pageComponent: 'WayISeeIt',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.POINTOFVIEW,
        image: 'TheWayISeeIt_cover.jpg',
    },
    {
        pageComponent: 'GlobeTrotter',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        image: 'GlobeTrekker_cover.jpg',
    },
    {
        pageComponent: 'Essential',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.POINTOFVIEW,
        image: 'Essential_cover.jpg',
    },
    {
        pageComponent: 'Legal',
        theme: ETheme.LIGHT,
        intro: EMenuIntro.DEFAULT,
        image: 'Legal_cover.gif',
    },
];
